import React from "react";

import { ProductMenuListItem } from "./ProductMenuListItem";
import { ReactComponent as DessertIcon } from "../../../../../assets/images/react-svg/dessert.icon.svg";
import { ReactComponent as DrinkIcon } from "../../../../../assets/images/react-svg/drink.icon.svg";
import { MENU_SECTIONS, PRODUCT_TYPES } from "../../../../api/products/productBaseConstants";

// bento: {
//   position: 2,
//   anchor: 'bento',
//   title: 'Бенто'
// },
const MENU_ITEMS = {
  rollset: {
    id: PRODUCT_TYPES.rollset.id,
    position: 1,
    anchor: 'rollset',
    title: 'Сеты',
    isNew: true,
  },
  sushi: {
    id: PRODUCT_TYPES.roll.id,
    position: 2,
    anchor: 'sushi',
    title: 'Суши',
    isNew: true,
  },
  sauce: {
    id: PRODUCT_TYPES.garnish.subtypes.sauce.id,
    position: 3,
    anchor: 'sauce',
    title: 'Соусы'
  },
  poke: {
    id: PRODUCT_TYPES.poke.id,
    position: 4,
    anchor: 'poke',
    title: 'Поке'
  },
  soup: {
    id: PRODUCT_TYPES.soup.id,
    position: 5,
    anchor: 'soup',
    title: 'Супы'
  },
  hot: {
    id: MENU_SECTIONS.hot,
    position: 6,
    anchor: MENU_SECTIONS.hot,
    title: 'Горячее',
  },
  snacks: {
    id: MENU_SECTIONS.snacks,
    position: 7,
    anchor: MENU_SECTIONS.snacks,
    title: 'Закуски',
  },
  dessert: {
    id: PRODUCT_TYPES.dessert.id,
    position: 8,
    anchor: PRODUCT_TYPES.dessert.id,
    Icon: DessertIcon,
  },
  drinks: {
    id: PRODUCT_TYPES.drink.id,
    position: 9,
    anchor: PRODUCT_TYPES.drink.id,
    Icon: DrinkIcon,
  },
};

export const ProductsMenu = () => {
  return (
    <div className="mx-auto pc:mx-0 w-full text-[11px] tab:text-t20 leading-[12px] tab:leading-[20px] font-bold flex justify-between items-end gap-x-1.5 tab:gap-x-4 max-w-full tab:max-w-[500px] overflow-x-auto pc:overflow-visible">
      {Object.values(MENU_ITEMS)
        .sort((a, b) => +a.position > +b.position ? 1 : -1)
        .map((menuElement) => {
          return (
            <ProductMenuListItem
              id={menuElement.id}
              isNew={menuElement.isNew}
              Icon={menuElement.Icon}
              hash={menuElement.anchor}
              title={menuElement.title}
              key={`menuitem_${menuElement.anchor}`}/>
          )
        })}
    </div>
  )

};
